module.exports = __webpack_public_path__ + "img/app-boduo.62c7ca2f.webp";